const regexExp = /^\d+(\.\d+)?%$/;

export const validatePercentageString = (value: string) => 
({ isValid: regexExp.test(value), value: Number(value.split('%')[0])});